module.exports = {
  "idPrimary": 665254,
  "dateCreated": "2018-10-15T15:13:44-05:00",
  "dateModified": "2018-11-01T15:19:15-05:00",
  "idEntity": "9eef137e53",
  "isInternational": false,
  "type": "office",
  "isVisible": true,
  "contactName": ".DEMO",
  "company": "CENTURY 21-JUDGE FITE COMPANY",
  "address1": "STREET 1",
  "address2": "STREET 2",
  "city": "CITY",
  "state": "TX",
  "postalCode": "ZIP",
  "plus4": null,
  "deliveryPoint": null,
  "checkDigit": null,
  "countryCode": "US",
  "contactPhone": "111.111.1111",
  "cassStatus": true,
  "failed": true,
  "errorCode": ""
};
